import TagManager from 'react-gtm-module';

const CONSENT_COOKIE_PREFIX = 'cc_consentCookie=';

type TrackingWindow = Window & {
	dataLayer?: unknown[];
	fbq?: (...parameters: unknown[]) => void;
};

export function hasTrackingConsent(cookieString: string): boolean {
	try {
		const cookies = cookieString.split(';').map(cookie => cookie.trim())
			.filter(cookie => cookie.startsWith(CONSENT_COOKIE_PREFIX));
		if (cookies.length !== 1) {
			return false;
		}
		const consent = JSON.parse(decodeURIComponent(cookies[0].slice(CONSENT_COOKIE_PREFIX.length)));
		const family = consent?.motorrad_australia_family;
		return family?.cdc === 1 && family?.cmm?.advertising === 1;
	} catch {
		return false;
	}
}

function revokeTrackingConsent(): void {
	const trackingWindow = window as TrackingWindow;
	try {
		trackingWindow.fbq?.('consent', 'revoke');
	} finally {
		const dataLayer = trackingWindow.dataLayer || (trackingWindow.dataLayer = []);
		function updateConsent(...parameters: unknown[]): void {
			dataLayer.push(arguments);
		}
		updateConsent('consent', 'update', {
			analytics_storage: 'denied',
			ad_storage: 'denied',
			ad_user_data: 'denied',
			ad_personalization: 'denied',
		});
	}
}

export function startConsentTracking(onWithdraw = () => window.location.reload()): () => void {
	let initializationAttempted = false;
	let withdrawalAttemptedAt: number | undefined;
	let stopped = false;
	let interval: number;

	const stop = () => {
		stopped = true;
		window.clearInterval(interval);
		window.removeEventListener('focus', checkConsent);
		window.removeEventListener('pageshow', checkConsent);
		document.removeEventListener('visibilitychange', checkConsent);
	};

	function checkConsent(): void {
		if (stopped) {
			return;
		}
		let allowed = false;
		try {
			allowed = hasTrackingConsent(document.cookie);
		} catch {
			allowed = false;
		}
		if (allowed && withdrawalAttemptedAt === undefined) {
			if (!initializationAttempted) {
				initializationAttempted = true;
				try {
					TagManager.initialize({ gtmId: 'GTM-KRGNHZ8' });
				} catch {
					return;
				}
			}
		} else if (initializationAttempted) {
			const now = Date.now();
			if (withdrawalAttemptedAt !== undefined && now - withdrawalAttemptedAt < 5000) {
				return;
			}
			withdrawalAttemptedAt = now;
			try {
				try {
					revokeTrackingConsent();
				} finally {
					onWithdraw();
				}
			} catch {
				return;
			}
		}
	}

	interval = window.setInterval(checkConsent, 500);
	window.addEventListener('focus', checkConsent);
	window.addEventListener('pageshow', checkConsent);
	document.addEventListener('visibilitychange', checkConsent);
	checkConsent();
	return stop;
}
